const gridOptions = {
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "#CECECE",
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: "#CECECE",
            zeroLineColor: "rgba(0,0,0,0.02)",
          },
          position: "left",
          ticks: {
            beginAtZero: true,
            suggestedMax: 9,
            mirror: false,
          },
        },
      ],
    },
  };

  export {gridOptions};